import React, { Component } from 'react';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { TextField, FormHelperText, FormControl } from '@mui/material';

class DatePickerInput extends Component {
    constructor(props) {
        super(props);
        if (props.value) {//if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value };
            this.updateStore(props.value);
        }else if (props.defaultValue){
            this.state = { ...this.state, value: props.defaultValue };
            this.updateStore(props.defaultValue);
        }else{ //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: null };
            this.props.dispatch({ type: types.FORM_INPUT, value: "", name: props.name });
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value) {
            // Convert the new value to local time
            this.setState({ value: newProps.value });
        } else if (!newProps.value) {
            this.setState({ value: null });
        }

        if (newProps.error && newProps.error !== this.state.error) {
            this.setState({ error: newProps.error });
        }
    }

    onChange = (newValue) => {
        // console.log(typeof newValue, newValue, JSON.stringify(newValue), newValue === "Invalid Date");
        if (newValue) {
            this.updateStore(newValue);
        } else {
            this.updateStore(null);
        }

        if (this.props.onChange){
            this.props.onChange(newValue);
        }
    }

    updateStore(value) {
        this.setState({ value });
        if (value && JSON.stringify(value) !== "null"){
            const formattedDate = dayjs(value).format('YYYY-MM-DD');
            this.props.dispatch({ type: types.FORM_INPUT, value: `${formattedDate}T00:00:00`, name: this.props.name });
            this.props.dispatch({ type: types.FORM_ERROR, name: this.props.name, error: `` }); // Clear Redux error
        }else{
            this.props.dispatch({ type: types.FORM_INPUT, value: null, name: this.props.name });
            this.props.dispatch({ type: types.FORM_ERROR, name: this.props.name, error: "Invalid Date" }); // Show Redux error
        }        
    }

    render() {
        const p = this.props;
        const { error, ...datepickerProps } = { ...p };
        const { value } = this.state || {};

        return (
            <div className="form-group DatePicker">
                <FormControl className={`${p.className} ${error && p.required ? 'error' : ``}`} error={error && p.required} fullWidth>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        {...datepickerProps}
                        value={value} // Display the local date
                        onChange={this.onChange} // Handle change with UTC conversion
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                InputLabelProps={{ shrink: true }}
                                id={p.id}
                                label={p.floatingLabelText || p.label || ""}
                                error={p.required && Boolean(error)}
                                helperText={this.hintText || ''}
                                InputProps={{
                                    ...params.InputProps,
                                    inputMode: 'numeric', // Allows numeric input only
                                    pattern: '[0-9]*', // Validates numbers only
                                }}
                            />
                        )}
                    />
                    {p.required && error ? <FormHelperText>{error}</FormHelperText> : null}
                </LocalizationProvider>
                </FormControl>

            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    // console.log('DatePickerInput mapStateToProps', state, props);
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name]
    };
};

export default connect(mapStateToProps)(DatePickerInput);
